import React, {Component} from 'react';
import {Select, Input, Form} from "antd";

const { TextArea } = Input;

class TextareInput extends Component {
    constructor(props) {
        super(props);
        this.state={
            content: props.itemValue || "",
        }
    }
    componentDidMount() {
    }
    render() {
        return (
            <Form.Item label={this.props.label} required={this.props.required} style={{display:"flex"}}>
                <Input.TextArea placeholder={this.props.placeholder}
                                value={this.state.content}
                                rows={4}
                                style={{width:"655px", background: "rgba(0, 80, 179, 0.04)",border: "1px solid rgba(0, 80, 179, 0.08)",resize:"none" }}
                                onChange={(e)=>{
                                    let content = e.target.value;
                                    this.setState({content},()=>{
                                        this.props.callBack&& this.props.callBack(content)
                                    });
                                }}
                />
            </Form.Item>
        );
    }
}

export default TextareInput;